import { render, staticRenderFns } from "./WebsiteSection.vue?vue&type=template&id=4312a944"
import script from "./WebsiteSection.vue?vue&type=script&lang=js"
export * from "./WebsiteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports